import React from 'react';
import YouTubePlayer from './YouTubePlayer';
import HostedVideoPlayer from './DropboxPlayer';

export type VideoSource = 'youtube' | 'dropbox' | 'file';

interface VideoPlayerProps {
  videoUrl: string;
  videoSource: VideoSource;
  sessionId?: string | null;
  selectedTtmlChecksum?: string | null;
  selectedTranscriptChecksum?: string | null;
  totalDuration?: number;
  token?: string;
  speakerSegments?: Map<number, any[]>;
  speakerLabels?: Record<number, string>;
  isVisible: boolean;
  onClose: () => void;
  onTimeUpdate: (time: number) => void;
  onDurationChange: (duration: number) => void;
  onPlayStateChange: (isPlaying: boolean) => void;
  onReady: () => void;
  currentTime?: number;
  mediaSeekRequestId?: number;
  mediaSeekRequestTime?: number | null;
  isPlaying?: boolean;
  volume?: number;
  playbackRate?: number;
  isDarkMode: boolean;
  isMinimized?: boolean;
  onToggleMinimize?: () => void;
  onFloatingChange?: (isFloating: boolean) => void;
  isMobile?: boolean;
  mobileTopicTitle?: string | null;
  useExternalAudioSync?: boolean;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoUrl,
  videoSource,
  ...props
}) => {
  if (!videoUrl || !videoSource) {
    return null;
  }

  if (videoSource === 'youtube') {
    return <YouTubePlayer youtubeUrl={videoUrl} {...props} />;
  }

  if (videoSource === 'file') {
    return <HostedVideoPlayer videoUrl={videoUrl} {...props} />;
  }

  if (videoSource === 'dropbox') {
    console.warn('[VideoPlayer] Dropbox playback is disabled. Prepare the source in AWS first.');
    return null;
  }

  // Unknown video source
  console.warn('[VideoPlayer] Unknown video source:', videoSource);
  return null;
};

export default VideoPlayer;
